export const Leaf = ({ attributes, children, leaf }) => {
  if (leaf.fontSize) {
    children = (
      <span style={{ fontSize: `${leaf.fontSize}px` }}>{children}</span>
    );
  }
  if (leaf.color) {
    children = <span style={{ color: leaf.color }}>{children}</span>;
  }

  if (leaf.bold) {
    children = <strong>{children}</strong>;
  }

  if (leaf.italic) {
    children = <em>{children}</em>;
  }

  if (leaf.underline) {
    children = <u>{children}</u>;
  }
  if (leaf.strikethrough) {
    children = <del>{children}</del>;
  }

  return <span {...attributes}>{children}</span>;
};
